import React, {useState} from 'react';
import { autoSuggestOptionsInput } from '../../../autoSuggestions';
import { getUser, invoke } from '../../../AppServices';
import { FormHoc, Toast } from '../../../app-components';
import { validatePassword } from '../../../Lib/helpers';
import { ROUTES, selectEmployeeStatus } from '../../../Lib/constants';
import './switch.css'




const UserCheckBox = () => {
  // const dealerData = getUser()
  // const [isChecked, setIsChecked] = useState(dealerData?.dealer?.dealerReceiveOffers);
  // console.log('isChecked', isChecked)
  // setIsChecked(false)
  // const handleCheckboxChange = () => {
  //   if (isChecked) {
  //     setIsChecked(false);
  //   } else if (!isChecked) {
  //     setIsChecked(true);
  //   }
  //   console.log(isChecked)
  //   // dealerReceiveOffersEmail()
  // };

  // const dealerReceiveOffersEmail = async () => {
  //   try {
  //     const updateSettings = await invoke({
  //       id: 'dealerReceiveOffersEmail',
  //       paramValue: {
  //         data: {
  //           dealerId: dealerData.dealer._id,
  //           dealerReceiveOffers: isChecked ? false : true
  //         }
  //       },
  //     });

  //     Toast.show({
  //       message: 'Success',
  //       description: updateSettings.message,
  //       type: 'success',
  //       position: 'top',
  //       direction: 'left',
  //       duration: 5000,
  //     });

  //     // Additional logic if needed after successful deletion
  //   } catch (error) {
  //     // Handle errors if the deletion fails
  //     console.error('Error deleting inactive dealer:', error);
  //   }
  // };



  return (
    <div>
      <hr />

      <p style={{ fontSize: '1.5rem', marginBottom: '20px' }}>If you want to receive the offers email that we have sent to the customer, click on the button below.</p>

      <div>
        <label class="switch">
          <input type="checkbox"  />
          <span class="slider round"></span>
        </label>
      </div>
    </div>
  )
}









const UserWeekReport = () => {
  // const dealerData = getUser()
  // console.log('dealerData?.dealer?.dealerReceiveOffersEmail', dealerData?.dealer)
  // const [isChecked, setIsChecked] = useState(dealerData?.dealer?.dealerWeeklyReport === 'Yes' ? true : false);

  // console.log('isCheckedUserWeekReport', isChecked)

  // const handleCheckboxChange = (event) => {
  //   if (isChecked) {
  //     setIsChecked(false);
  //   } else if (!isChecked) {
  //     setIsChecked(true);
  //   }
  //   console.log('isCheckedUserWeekReport', isChecked)
  //   dealerReceiveWeeklyReport()
  // };

  // const dealerReceiveWeeklyReport = async () => {
  //   try {
  //     const updateSettings = await invoke({
  //       id: 'dealerReceiveWeeklyReport',
  //       paramValue: {
  //         data: {
  //           dealerId: dealerData.dealer._id,
  //           dealerWeeklyReport: isChecked ? 'No' : 'Yes'
  //         }
  //       },
  //     });

  //     Toast.show({
  //       message: 'Success',
  //       description: updateSettings.message,
  //       type: 'success',
  //       position: 'top',
  //       direction: 'left',
  //       duration: 5000,
  //     });

  //     // Additional logic if needed after successful deletion
  //   } catch (error) {
  //     // Handle errors if the deletion fails
  //     console.error('Error deleting inactive dealer:', error);
  //   }
  // };



  return (
    <div>
      <hr />

      <p style={{ fontSize: '1.5rem', marginBottom: '20px' }}>
        If you wish to receive the weekly report for your account, including details such as Appraisals Captured, Generated, and Failed, click on the button below.</p>

      <div>
        <label class="switch">
          <input type="checkbox"  />
          <span class="slider round"></span>
        </label>
      </div>
    </div>
  )
}

const UserModalWeeklyReport = () => {
  // const dealerData = getUser()
  // const [isChecked, setIsChecked] = useState(dealerData?.dealer?.dealerModalWeeklyReport === 'Yes' ? true : false);


  // const handleCheckboxChange = (event) => {
  //   if (isChecked) {
  //     setIsChecked(false);
  //   } else if (!isChecked) {
  //     setIsChecked(true);
  //   }
  //   console.log('isCheckedUserWeekReport', isChecked)
  //   dealerModalWeeklyReport()
  // };

  // const dealerModalWeeklyReport = async () => {
  //   try {
  //     const updateSettings = await invoke({
  //       id: 'dealerReceiveModalWiseWeekly',
  //       paramValue: {
  //         data: {
  //           dealerId: dealerData.dealer._id,
  //           dealerModalWeeklyReport: isChecked ? 'No' : 'Yes'
  //         }
  //       },
  //     });

  //     Toast.show({
  //       message: 'Success',
  //       description: updateSettings.message,
  //       type: 'success',
  //       position: 'top',
  //       direction: 'left',
  //       duration: 5000,
  //     });

  //     // Additional logic if needed after successful deletion
  //   } catch (error) {
  //     // Handle errors if the deletion fails
  //     console.error('Error deleting inactive dealer:', error);
  //   }
  // };



  return (
    <div>
      <hr />

      <p style={{ fontSize: '1.5rem', marginBottom: '20px' }}>
        If you would like to receive the weekly report of appraisals generated, categorized by models, click on the button below.</p>

      <div>
        <label class="switch">
          <input type="checkbox" />
          <span class="slider round"></span>
        </label>
      </div>
    </div>
  )
}


const CustomerInterestNoti = () => {
  // const dealerData = getUser()
  // const [isChecked, setIsChecked] = useState(dealerData?.dealer?.customerInterestNoti === 'Yes' ? true : false);
  const [isChecked, setIsChecked] = useState(false);


  // const handleCheckboxChange = (event) => {
  //   if (isChecked) {
  //     setIsChecked(false);
  //   } else if (!isChecked) {
  //     setIsChecked(true);
  //   }
  //   console.log('isCheckedUserWeekReport', isChecked)
  //   dealerModalWeeklyReport()
  // };

  // const dealerModalWeeklyReport = async () => {
  //   try {
  //     const updateSettings = await invoke({
  //       id: 'customerInterestNotification',
  //       paramValue: {
  //         data: {
  //           dealerId: dealerData.dealer._id,
  //           customerInterestNoti: isChecked ? 'No' : 'Yes'
  //         }
  //       },
  //     });

  //     Toast.show({
  //       message: 'Success',
  //       description: updateSettings.message,
  //       type: 'success',
  //       position: 'top',
  //       direction: 'left',
  //       duration: 5000,
  //     });

  //     // Additional logic if needed after successful deletion
  //   } catch (error) {
  //     // Handle errors if the deletion fails
  //     console.error('Error deleting inactive dealer:', error);
  //   }
  // };



  return (
    <div>
      <hr />

      <p style={{ fontSize: '1.5rem', marginBottom: '20px' }}>
        If you would like to receive notifications when a customer shows interest in an appraisal offer, click on the button below.
      </p>
      <div>
        <label class="switch">
          <input type="checkbox"  />
          <span class="slider round"></span>
        </label>
      </div>
    </div>
  )
}


const AddEmployeeForm = FormHoc({
  type: 'standard',
  reloadEvent: ROUTES.employeeData.name,
  closeView: 1,
  onSubmit: async (data) => {
    console.log('data', data)
    const { result } = await invoke({
      id: 'handleEmployeeSubmit',
      paramValue: data.data,
    });

    Toast.show({
      message: result.message,
      description: result.description,
      type: result.type,
      position: 'top',
      direction: 'left',
      duration: 3000,
    });
  },
  validations: {
    password: ({ data }) => validatePassword(data.password),
    confirm_password: ({ data }) => {
      if (data.confirm_password !== data.password) {
        return 'Password and confirm password should match.';
      }
    },
  },
  defaultValues: () => {
    const user = getUser();
    return {
      dealer: user.dealer,
      
    };
  },
  mandatory: {
    username: 'This field is mandatory.',
    firstName: 'This field is mandatory.',
    lastName: 'This field is mandatory.',
    password: 'This field is mandatory.',
    confirm_password: 'This field is mandatory.',
    email: 'This field is mandatory.',
    role: 'This field is mandatory.',
  },
  fieldContainer: 'topLabel',
  lg: {
    formGroups: [
      {
        columnsPerRow: 2,
        fieldVariant: 'filled',
        groups: [
          {
            columns: [
              {
                type: 'text',
                field: 'username',
                label: 'Employee Username',
                placeholder: 'Enter Employee Username',
                mandatory: true,
              },
              {
                type: 'text',
                field: 'firstName',
                label: 'Employee First Name',
                placeholder: 'Enter Employee First Name',
                allowWhiteSpaces: true,
                mandatory: true,
              },
              {
                type: 'text',
                field: 'lastName',
                label: 'Employee Last Name',
                placeholder: 'Enter Employee Last Name',
                mandatory: true,
                allowWhiteSpaces: true,
              },
              {
                type: 'text',
                field: 'email',
                label: 'Employee Email',
                placeholder: 'Enter Employee Email',
                mandatory: true,
                allowWhiteSpaces: true,
              },
              {
                type: 'password',
                field: 'password',
                label: 'Password',
                placeholder: 'Enter Password',
                mandatory: true,
              },
              {
                type: 'password',
                field: 'confirm_password',
                label: 'Confirm Password',
                placeholder: 'Re-enter Password',
                mandatory: true,
              },
              autoSuggestOptionsInput({
                label: 'Role',
                field: 'role',
                suggestionField: 'label',
                valueField: 'label',
                options: selectEmployeeStatus,
                keyField: 'label',
              }),
            ],
          },
        ],
      },
      // {
      //   columnsPerRow: 2,
      //   groups: [
      //     {
      //       columns: [

      //         <UserCheckBox  />
      //         ,
      //         <UserWeekReport />
      //         ,
      //         <UserModalWeeklyReport  />
      //         ,
      //         <CustomerInterestNoti  />
      //         ,
      //       ],
      //     },
      //   ],
      // },
    ],
  },
});

const AddEmployee = (props) => <AddEmployeeForm {...props} />;

export default AddEmployee;
